var map = {
	"./template.bet777": 1692,
	"./template.bet777.tsx": 1692,
	"./template.default": 265,
	"./template.default.tsx": 265,
	"./template.puntcity": 1693,
	"./template.puntcity.tsx": 1693,
	"./template.sterlingparker": 1694,
	"./template.sterlingparker.tsx": 1694,
	"./template.templebet": 1695,
	"./template.templebet.tsx": 1695,
	"./template.ts": 987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;